const { logger } = require('redux-logger')

export default logger
